module.exports = __webpack_public_path__ + "static/media/divider.d6cfdc04.png";